import type { AssetFieldsFragment, RecordFieldsFragment } from "@auger/core/gql/types"
import { getAssetUrl } from "@/composables/useAssets"
import { getAuger } from "@/init/auger"
import type { ComposableDeps } from "./types"

export function useAvatarWrite(deps: ComposableDeps) {
  // Makes an uploaded asset the record's `avatar` — an image field, so the
  // record_attachments row is the value — and patches record.avatar in place so
  // the new picture shows before the next read.
  function attachAndUpdate(
    asset: AssetFieldsFragment,
    record: Pick<RecordFieldsFragment, "id"> & { avatar?: { url?: string | null } | null }
  ): Promise<string | null> {
    const assetUrl = getAssetUrl(asset)
    return getAuger(deps.client)
      .records.update(record.id, { avatar: [asset.id] }, { read: false })
      .then(() => {
        record.avatar = { url: assetUrl }
        return assetUrl
      })
      .catch((err: unknown) => {
        deps.toast?.error?.("Couldn't update avatar")
        throw err
      })
  }

  return { attachAndUpdate }
}
